class AlAnfarTrending extends HTMLElement {
  connectedCallback() {
    this.rail = this.querySelector('.aa-layout--mobile-scroll');
    this.controls = this.querySelector('[data-trending-controls]');
    this.previous = this.querySelector('[data-trending-previous]');
    this.next = this.querySelector('[data-trending-next]');
    if (!this.rail || !this.controls || !this.previous || !this.next) return;

    this.handleScroll = () => this.updateControls();
    this.previous.addEventListener('click', () => this.scroll(-1));
    this.next.addEventListener('click', () => this.scroll(1));
    this.rail.addEventListener('scroll', this.handleScroll, { passive: true });
    this.resizeObserver = new ResizeObserver(this.handleScroll);
    this.resizeObserver.observe(this.rail);
    requestAnimationFrame(this.handleScroll);
  }

  disconnectedCallback() {
    this.rail?.removeEventListener('scroll', this.handleScroll);
    this.resizeObserver?.disconnect();
  }

  scroll(direction) {
    const item = this.rail.querySelector('.aa-product');
    const gap = Number.parseFloat(getComputedStyle(this.rail).columnGap) || 0;
    const distance = item ? item.getBoundingClientRect().width + gap : this.rail.clientWidth * .84;
    this.rail.scrollBy({ left: direction * distance, behavior: 'smooth' });
  }

  updateControls() {
    const max = this.rail.scrollWidth - this.rail.clientWidth;
    const hasOverflow = max > 2;
    this.controls.hidden = !hasOverflow;
    this.previous.disabled = this.rail.scrollLeft <= 2;
    this.next.disabled = this.rail.scrollLeft >= max - 2;
  }
}

if (!customElements.get('al-anfar-trending')) {
  customElements.define('al-anfar-trending', AlAnfarTrending);
}
